module.exports = __webpack_public_path__ + "static/media/solutions-bg.21f8d008.avif";